export default __webpack_public_path__ + "static/media/1279.4422304f.png";